import { render, staticRenderFns } from "./CategorySaveEditDialog.vue?vue&type=template&id=6e6af5d9"
import script from "./CategorySaveEditDialog.vue?vue&type=script&lang=js"
export * from "./CategorySaveEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports